import { FiCheckCircle } from "react-icons/fi";
import SkeletonBase from "newui/components/Skeleton";
import { useMyScores } from "../../../../../hooks/usePanelScoringQueries";
import { ReadOnlyScoreTable } from "./ReadOnlyScoreTable";


interface SubmitConfirmationProps {
	evalId: number;
	rfxId: number;
	submittedAt?: string | null;
	onAddClarification?: (inviteId: number) => void;
}

const formatDate = (dateStr: string | null | undefined): string => {
	if (!dateStr) {
		return "";
	}
	const date = new Date(dateStr);
	return date.toLocaleDateString("en-AU", {
		day: "2-digit",
		month: "short",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	});
};

export const SubmitConfirmation: React.FC<SubmitConfirmationProps> = ({
	rfxId,
	evalId,
	submittedAt,
	onAddClarification,
}) => {
	const { data, isLoading } = useMyScores(rfxId, evalId);

	return (
		<div className="space-y-4" data-testid="submit-confirmation">
			<div className="flex items-center gap-3 rounded-lg border border-green-200 bg-green-50 px-4 py-3">
				<FiCheckCircle size={20} className="shrink-0 text-green-600" aria-hidden="true" />
				<div>
					<p className="text-sm font-medium text-green-800">
						Your scores have been submitted
					</p>
					{submittedAt && (
						<p className="text-xs text-green-600">
							Submitted on {formatDate(submittedAt)}
						</p>
					)}
					<p className="mt-1 text-xs text-green-700">
						Your evaluation is complete. The RFx Lead will review all panel
						submissions and proceed to the next step.
					</p>
				</div>
			</div>

			<div>
				<h4 className="mb-3 text-sm font-medium text-gray-700">
					Your submitted scores (read-only)
				</h4>
				{isLoading ? (
					<div className="space-y-2">
						{[1, 2].map((i) => (
							<SkeletonBase key={i} startColor="lightgray" width="100%" height="48px" className="!rounded-lg" />
						))}
					</div>
				) : (
					<ReadOnlyScoreTable suppliers={data?.suppliers ?? []} rfxId={rfxId} onAddClarification={onAddClarification} />
				)}
			</div>
		</div>
	);
};
